import { render, staticRenderFns } from "./loanDetails.vue?vue&type=template&id=d0e126b8&scoped=true&lang=html"
import script from "./loanDetails.vue?vue&type=script&lang=js"
export * from "./loanDetails.vue?vue&type=script&lang=js"
import style0 from "./loanDetails.vue?vue&type=style&index=0&id=d0e126b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e126b8",
  null
  
)

export default component.exports